import Vue from 'vue'
import App from './App.vue'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import LoadScript from 'vue-plugin-load-script'
import vuetimeline from "@growthbunker/vuetimeline"

Vue.use(VueToast, { position: "top" });
Vue.use(LoadScript);
Vue.use(vuetimeline, {
  theme: "light",
})

window.$ = require('jquery')
window.jQuery = require('jquery')

import 'bootstrap/dist/js/bootstrap.bundle'
import './registerServiceWorker'
import router from './router'
import titular from "@/components/Titular.vue"
import modal from "@/components/Modal.vue"
import iSubmit from "@/components/ISubmit.vue"
import vacio from "@/components/Vacio.vue"

Vue.config.productionTip = false;
Vue.prototype.$http = require("axios");

const auth = Vue.observable({ auth: null });

Object.defineProperty(Vue.prototype, '$auth', {
  get() { return auth.auth; },
  set(value) { auth.auth = value; }
});

Vue.prototype.$http.defaults.headers.common["X-Api-Key"] = process.env.VUE_APP_X_API_KEY;
Vue.prototype.$http.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  (error) => {
    const { status, data } = error.response;

    if (status >= 500) {
      Vue.prototype.$toast.open({ type: "error", position: "top", duration: 0, message: `Error greu ${status}: ${data.error ?? "error sense identificar."}` });
    }

    if (status >= 400 && status < 500) {
      switch (status) {
        case 401:
          Vue.prototype.$auth = false;

          break;
        case 403:
          Vue.prototype.$toast.clear();
          Vue.prototype.$toast.open({ type: "warning", position: "top", message: `${data.error ?? "No tens suficients privilegis per a realitzar aquesta acció."}` });

          break;
        case 405:
          Vue.prototype.$toast.open({ type: "error", position: "top", duration: 0, message: `Aquesta acció no es pot fer perquè no està disponible.` });

          break;
        default:
          Vue.prototype.$toast.open({ type: "warning", position: "top", duration: 0, message: `Error ${status}: ${data.error ?? "error sense identificar."}` });

          return Promise.resolve(error);
      }
    }

    return Promise.reject(error);
  }
);

Vue.component('titular', titular);
Vue.component('modal', modal);
Vue.component('i-submit', iSubmit);
Vue.component('vacio', vacio);
Vue.component('VueBootstrap4Table', VueBootstrap4Table);

Vue.directive('tooltip', function (el, binding) {
  let placement = ((binding.arg) ? binding.arg : "top");
  jQuery(el).tooltip({
    placement: placement
  });
});

Vue.directive('popover', function (el, binding) {
  jQuery(el)
    .attr("data-toggle", "popover")
    .popover({
      template: /*html*/`
      <div class="popover" role="tooltip">
        <div class="arrow"></div>
        <div>
          <h3 class="popover-header pr-4"></h3>
          <span class="popover-close position-absolute m-1" role="button"><i class="fa-solid fa-circle-xmark"></i></span>
        </div>
        <div class="popover-body"></div>
      </div>
      `,
      offset: jQuery(el).attr("data-offset") ?? 0,
    });
});

router.beforeEach((to, from, next) => {
  Vue.prototype.$http.get(`api/routes?path=${to.fullPath}`)
    .then((response) => {
      next(response.status == 200);
    })
    .catch((error) => {
      if (from.path == "/" && to.path != "/") {
        next("/");
      }
    });
})

router.afterEach((to, from) => {
  Vue.nextTick(() => document.title = to.name);
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
